var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuickMenuCircleOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 415,
    height: 416,
    viewBox: "0 0 415 416",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_90_339)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7759 184.252C17.9224 140.747 37.375 100.482 68.84 69.03C105.892 31.965 155.157 11.5653 207.555 11.5653C259.953 11.5653 309.204 31.965 346.256 69.03C377.721 100.495 397.174 140.747 402.32 184.252L413.36 178.865C399.307 77.763 312.524 -0.0742188 207.555 -0.0742188C102.586 -0.0742188 15.7758 77.763 1.73633 178.865L12.7759 184.238V184.252ZM402.12 232.797C396.694 275.702 377.321 315.353 346.256 346.432C309.217 383.471 259.953 403.883 207.555 403.883C155.157 403.883 105.906 383.471 68.854 346.432C37.775 315.353 18.4023 275.688 12.9759 232.783L1.88303 237.53C16.3357 338.179 102.919 415.523 207.555 415.523C312.191 415.523 398.774 338.179 413.213 237.53L402.12 232.783V232.797Z",
    fill: "url(#paint0_linear_90_339)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M207.555 409.831C113.719 409.831 34.295 348.7 7.57617 264.41C32.255 351.62 112.439 415.511 207.555 415.511C302.671 415.511 382.841 351.62 407.52 264.41C380.801 348.7 301.378 409.831 207.555 409.831Z",
    fill: "url(#paint1_linear_90_339)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5,
    d: "M407.52 151.026C382.841 63.817 302.658 -0.0742188 207.555 -0.0742188C112.452 -0.0742188 32.255 63.817 7.57617 151.026C34.295 66.75 113.719 6.19218 207.555 6.19218C301.391 6.19218 380.801 66.736 407.52 151.026Z",
    fill: "url(#paint2_linear_90_339)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M207.555 409.831C113.719 409.831 34.295 348.7 7.57617 264.41C32.255 351.62 112.439 415.511 207.555 415.511C302.671 415.511 382.841 351.62 407.52 264.41C380.801 348.7 301.378 409.831 207.555 409.831Z",
    fill: "url(#paint3_linear_90_339)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5,
    d: "M407.52 151.026C382.841 63.817 302.658 -0.0742188 207.555 -0.0742188C112.452 -0.0742188 32.255 63.817 7.57617 151.026C34.295 66.75 113.719 6.19218 207.555 6.19218C301.391 6.19218 380.801 66.736 407.52 151.026Z",
    fill: "url(#paint4_linear_90_339)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.173 284.924C9.87727 244.674 6.59107 200.077 18.115 157.106C31.67 106.481 64.135 64.1821 109.513 37.9831C154.891 11.7845 207.744 4.82508 258.364 18.3985C301.347 29.9161 338.319 55.0481 364.528 90.1511L371.396 79.9671C308.674 -0.564125 194.599 -24.5812 103.693 27.9031C12.7873 80.3881 -23.4738 191.202 14.919 285.779L27.166 284.912L27.173 284.924ZM388.627 132.292C405.38 172.162 408.429 216.188 397.065 258.636C383.508 309.231 351.05 351.542 305.672 377.741C260.294 403.94 207.435 410.887 156.828 397.337C114.373 385.961 77.764 361.297 51.612 326.853L44.378 336.51C107.219 416.449 220.874 440.139 311.492 387.821C402.109 335.503 438.42 225.23 400.601 130.845L388.621 132.281L388.627 132.292Z",
    fill: "url(#paint5_linear_90_339)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M308.646 382.891C227.381 429.809 128.033 416.58 62.749 356.942C127.726 420.129 229.113 435.368 311.486 387.81C393.859 340.252 431.343 244.836 409.111 156.97C428.116 243.327 389.899 335.98 308.646 382.891Z",
    fill: "url(#paint6_linear_90_339)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.172 284.922C9.87637 244.673 6.59027 200.076 18.1141 157.105C31.669 106.479 64.134 64.1806 109.512 37.9816C154.89 11.7825 207.743 4.82297 258.363 18.3965C301.346 29.9136 338.318 55.0466 364.527 90.1496L367.813 85.2816C340.923 49.9856 303.357 24.7036 259.803 13.0237C207.75 -0.923826 153.392 6.22757 106.732 33.1666C60.073 60.1056 26.689 103.612 12.7461 155.647C1.07277 199.212 4.17967 244.405 21.3128 285.334L27.172 284.922ZM388.627 132.291C405.38 172.161 408.428 216.187 397.064 258.634C383.507 309.23 351.049 351.54 305.671 377.739C260.293 403.938 207.434 410.886 156.827 397.336C114.372 385.96 77.763 361.295 51.611 326.852L48.155 331.479C74.983 366.241 112.252 391.141 155.387 402.708C207.44 416.656 261.803 409.486 308.451 382.554C355.099 355.622 388.483 312.115 402.437 260.074C413.993 216.946 411.046 172.215 394.355 131.601L388.627 132.291Z",
    fill: "url(#paint7_linear_90_339)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5,
    d: "M352.419 58.7785C287.441 -4.40844 186.055 -19.6477 103.693 27.9035C21.3317 75.4555 -16.1754 170.884 6.05687 258.75C-12.9421 172.404 25.562 80.2485 106.826 33.3305C188.091 -13.5875 287.134 -0.859844 352.419 58.7785Z",
    fill: "url(#paint8_linear_90_339)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_90_339",
    x1: 207.541,
    y1: -0.0742188,
    x2: 207.541,
    y2: 415.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_90_339",
    x1: 207.542,
    y1: 264.41,
    x2: 207.542,
    y2: 415.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_90_339",
    x1: 207.542,
    y1: 151.04,
    x2: 207.542,
    y2: -0.0742188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_90_339",
    x1: 207.542,
    y1: 264.41,
    x2: 207.542,
    y2: 415.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_90_339",
    x1: 207.542,
    y1: 151.04,
    x2: 207.542,
    y2: -0.0742188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_90_339",
    x1: 103.682,
    y1: 27.9101,
    x2: 311.48,
    y2: 387.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_90_339",
    x1: 235.924,
    y1: 256.96,
    x2: 311.481,
    y2: 387.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_90_339",
    x1: 308.439,
    y1: 382.561,
    x2: 106.721,
    y2: 33.1736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_90_339",
    x1: 179.239,
    y1: 158.778,
    x2: 103.682,
    y2: 27.9105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADBEDF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_90_339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 415,
    height: 416,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickMenuCircleOne);
export default __webpack_public_path__ + "static/media/quick-menu-circle-one.f90fb8bf3d750104c95a973de6a54cfd.svg";
export { ForwardRef as ReactComponent };